import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterContentChecked,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-qty-input',
  templateUrl: './qty-input.component.html',
  styleUrls: ['./qty-input.component.scss'],
})
export class QtyInputComponent implements OnInit, AfterContentChecked {
  @ViewChild('qtyInput') qtyInput: ElementRef<HTMLInputElement>;
  @Input() dontHaveStock: boolean;
  @Input() isLoading: boolean;
  @Input() isQtyChange: boolean;
  @Input() currentQty: number;
  @Input() readyStock: number;

  @Output() addDecQty = new EventEmitter();
  @Output() changeQuantity = new EventEmitter();
  @Output() toggleIsChangeQty = new EventEmitter();

  constructor(private toastController: ToastController) {}

  ngOnInit() {}

  ngAfterContentChecked() {
    if (this.isQtyChange && this.qtyInput) {
      this.qtyInput.nativeElement.focus();
    }
  }

  qtyDisplay(num: number) {
    const isOneDigit = num?.toString().length === 1;

    if (isOneDigit) {
      return '0' + num;
    }

    return num;
  }

  addDecQtyHandler(qty: 1 | -1) {
    if (this.readyStock <= 1) {
      return;
    }

    // if on increment mode, and current qty >= ready_stock, then disabled.
    if (qty === 1 && this.currentQty >= this.readyStock) {
      return;
    }

    if ((this.currentQty > 1 && qty === -1) || qty === 1) {
      // this.currentQty += qty;
      this.addDecQty.emit({ currentQty: (this.currentQty += qty) });
    }
  }

  toggleIsChangeQtyHandler() {
    if (this.readyStock <= 1) {
      return;
    }

    // this.isQtyChange = !this.isQtyChange;
    this.toggleIsChangeQty.emit({ isQtyChange: !this.isQtyChange });
  }

  changeQuantityHandler(event: any): void {
    const originalQty = this.currentQty;
    const value = event.target.value;
    const qty = parseInt(value.length === 0 ? '0' : value, 10);

    this.toggleIsChangeQty.emit({ isQtyChange: false });

    if (this.readyStock <= 1) {
      this.currentQty = originalQty;
      return;
    }

    if (qty > this.readyStock) {
      this.presentToast(
        `stok barang pada warehouse ini kurang dari ${qty}!, silahkan cek warehouse lainnya`,
        3000,
        'danger',
      );
    }

    // this.currentQty = qty;
    this.changeQuantity.emit({ currentQty: qty });
  }

  protected async presentToast(message: string, duration: number = 1000, color?: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
      color,
    });
    return await toast.present();
  }
}
